import { useState } from 'react';

export type bgColors =
	| 'white'
	| 'light'
	| 'dark'
	| 'primary'
	| 'yellow'
	| 'none'
	| undefined
	| null;

export type accentColors =
	| 'white'
	| 'yellow'
	| 'blue'
	| 'green'
	| 'orange'
	| undefined
	| null;

export const colorMap = {
	light: 'light-bg',
	dark: 'warm-grey',
	yellow: 'accent-1',
	orange: 'accent-2',
	blue: 'accent-3',
	green: 'accent-4',
	white: 'white',
	black: 'black',
	primary: 'primary',
	none: 'none',
};

export const useRandomID = (prefix) =>
	`${prefix ? `${prefix}-` : ''}${(Math.random() + 1)
		.toString(36)
		.substring(7)}`;

// custom hook handles the menu transitions
export function useTransition(initialState: any = '', timeout: number = 200) {
	const [activeEl, setActivEl] = useState(initialState);
	const [toggleClass, setToggleClass] = useState(false);

	function handler(elementName = '') {
		if (activeEl) {
			setToggleClass(true);
			setTimeout(() => {
				setToggleClass(false);

				if (activeEl === elementName) {
					setActivEl('');
				} else {
					setActivEl(elementName);
				}
			}, timeout);
		} else {
			setActivEl(elementName);
		}
	}

	return [activeEl, toggleClass, handler];
}
